import type { ComponentProps } from 'react';
import { OwcBadge } from '@one/react';

export type PocBadgeProps = ComponentProps<typeof OwcBadge>;

export const PocBadge: React.FC<PocBadgeProps> = (props) => <OwcBadge {...props} />;
